export const green = '#88C202'
export const darkBg = '#2A313B'
export const gray = 'rgb(246, 246, 247)'
export const gray2 = '#EDF2F4'
export const red = '#F16422'
export const bootstrapGray = '#ced4da'
